import React from 'react';
import {
  PARAGRAPH_SIZE,
  SUBTITLE_SIZE,
  TEXT_COLOR,
  TITLE_SIZE,
} from '~/utils/constants';
import { getButtonStyleClass } from '~/utils/helpers';
import { EngagementPanelImage } from '.';

const EngagementPanel: React.FC<EngagementPanelBlock> = ({
  template_title,
  template_subtitle,
  cta_buttons,
  engagement_panel_image,
  template_note,
}) => {
  const titleStyle = {
    color: template_title?.color ?? TEXT_COLOR,
    fontSize: `${template_title?.font_size ?? TITLE_SIZE}rem`,
    ...(template_title?.line_height && {
      lineHeight: `${template_title.line_height}`,
    }),
  };

  const subtitleStyle = {
    color: template_subtitle?.color ?? TEXT_COLOR,
    fontSize: `${template_subtitle?.font_size ?? SUBTITLE_SIZE}rem`,
    ...(template_subtitle?.line_height && {
      lineHeight: `${template_subtitle.line_height}`,
    }),
  };

  const noteStyle = {
    color: template_note?.color ?? TEXT_COLOR,
    fontSize: `${template_note?.font_size ?? PARAGRAPH_SIZE}rem`,
    ...(template_note?.line_height && {
      lineHeight: `${template_note.line_height}`,
    }),
  };

  return (
    <div className='flex w-full max-w-xl justify-center xl:max-w-lg lg:max-w-md md:px-4'>
      <div className='flex flex-1 items-center bg-text-primary py-12 pl-24 text-[#fff] border-rounded-strong lg:pr-24 sm:px-10'>
        <div className='w-2/3 lg:w-full'>
          {template_title?.text && (
            <h2
              className='text-4xl mb-10 font-bold text-[#fff]'
              dangerouslySetInnerHTML={{
                __html: template_title.text,
              }}
              style={titleStyle}
            />
          )}
          {template_subtitle?.text && (
            <p
              className='text-lg mt-4 text-[#fff]'
              dangerouslySetInnerHTML={{
                __html: template_subtitle.text,
              }}
              style={subtitleStyle}
            />
          )}
          {cta_buttons && (
            <div className='sm:items-left mt-6 flex flex-wrap gap-4 sm:my-12 sm:flex-col'>
              {cta_buttons.map((button, index) => {
                const styleClass = getButtonStyleClass(button.style);
                return (
                  <a
                    key={index}
                    href={button.url}
                    className={`bunny-button bunny-button--arrow ${styleClass} mx-0`}
                  >
                    {button.label}
                  </a>
                );
              })}
            </div>
          )}
          {template_note && (
            <p
              className='my-4 text-xs text-[#fff]'
              dangerouslySetInnerHTML={{
                __html: template_note.text,
              }}
              style={noteStyle}
            />
          )}
        </div>
        {engagement_panel_image && (
          <EngagementPanelImage image={engagement_panel_image} />
        )}
      </div>
    </div>
  );
};

export default EngagementPanel;
